import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Tabs, Tab } from '@mui/material';
import {
    hasSideBar,
    toggleSideBar,
    updateCurrentComponent,
} from '../../../store/actions/navActions';
import * as C from '../../../services/constants';
import SideNav from '../../common/SideNav';
import RaffleReport from './RaffleReport';
import WinnersReport from './WinnersReport';

const TAB_LIST = [
    {
        label: 'Raffle Entry Winners',
        tabId: 1,
        children: <RaffleReport />,
    },
    {
        label: 'Download Winners Report',
        tabId: 2,
        children: <WinnersReport />,
    },
];

const CustomerReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    const tabId = queryParams.get('tabId');
    const { auth } = useSelector((state) => state);
    const { market } = auth.user;

    const [tabValue, setTabValue] = useState(+tabId ?? 1);

    const handleTabChange = (_event, newValue) => {
        setTabValue(newValue);
        const params = new URLSearchParams(location.search);
        params.set('tabId', newValue);
        navigate(
            {
                pathname: location.pathname,
                search: params.toString(),
            },
            { replace: true }
        );
    };

    useEffect(() => {
        if (market !== 'PH') {
            navigate('/');
        }
    }, [market, navigate]);

    useEffect(() => {
        dispatch(updateCurrentComponent(C.APP_CUSTOMER_REPORT_PAGE_TITLE));
        dispatch(hasSideBar(true));
        dispatch(toggleSideBar(false));
    }, [dispatch]);

    return (
        <div className="component-container-root customer-report-root">
            <SideNav />
            <div className="component-container">
                <h2 className="customer-report-root-title">
                    Manage and download the winners data. Go to{' '}
                    <Link to="/help" title="Help" className="help-text">
                        ‘Help page’
                    </Link>{' '}
                    for information on how to download.
                </h2>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    aria-label="secondary tabs example"
                    sx={{ mb: 2 }}
                    gap={2}
                >
                    {Array.isArray(TAB_LIST) &&
                        TAB_LIST.length > 0 &&
                        TAB_LIST.map(({ label, tabId }) => {
                            const isCurrentTab = tabId === tabValue;
                            return (
                                <Tab
                                    label={label}
                                    value={tabId}
                                    sx={{
                                        bgcolor: isCurrentTab
                                            ? '#F4FCFF'
                                            : '#FAFAFA',
                                        borderBottom: isCurrentTab && 0,
                                        color: isCurrentTab
                                            ? '#13689E'
                                            : '#101010',
                                        textTransform: 'none',
                                        fontWeight: '800',
                                        fontSize: '18px',
                                        marginRight: '12px',
                                    }}
                                    key={tabId}
                                />
                            );
                        })}
                </Tabs>
                {Array.isArray(TAB_LIST) &&
                    TAB_LIST.length > 0 &&
                    TAB_LIST.filter(({ tabId }) => tabId === tabValue).map(
                        ({ children, tabId }) => (
                            <Fragment key={tabId}>{children}</Fragment>
                        )
                    )}
            </div>
        </div>
    );
};

export default CustomerReport;
